module.exports = __webpack_public_path__ + "static/media/child.ceb8b299.svg";